import _ from "lodash";

import { Notificator } from "../../../../components/notification";
import { getWebContentPreviewParams } from "../webFilteringForm/webContent.selectors";
import { isFailure, ResourceName } from "@sportal/api";

export const loadLogo =
  () =>
  async (dispatch, getState, { api }) => {
    const {
      subscriberInfo: { id },
    } = getState();
    const result = await api.ssm.bpResources.getLogo(id);

    if (isFailure(result)) {
      dispatch(Notificator.error("error_failed_to_load_data"));
      dispatch(generalFailure(result.error, LOAD_LOGO_FAILURE));
      return;
    }

    const logo = result.data;

    dispatch(loadLogoSuccess(logo.size > 0 ? URL.createObjectURL(logo) : null));
  };

export const saveBranding = () => (dispatch, getState) => {
  const {
    resources: {
      branding: { toSave, tagline, color },
    },
  } = getState();
  const palette = {
    color: toSave.color || color,
    tagline: _.isNull(toSave.tagline) ? tagline : toSave.tagline.trim(),
  };

  return dispatch(changeLogo(toSave.logo)).finally(() =>
    dispatch(changePalette(palette))
  );
};

export const changePalette =
  (palette) =>
  async (dispatch, getState, { api }) => {
    const {
      subscriberInfo: { id },
      resources: {
        branding: { color, tagline },
      },
    } = getState();

    if (
      (!palette.color && _.isNull(palette.tagline)) ||
      _.isEqual(palette, { color, tagline })
    ) {
      return Promise.resolve();
    }

    const result = await api.ssm.bpResources.updateResource(
      id,
      ResourceName.WebContent,
      palette
    );

    if (isFailure(result)) {
      dispatch(Notificator.error("couldnt_save_changes"));
      dispatch(generalFailure(result.error, CHANGE_PALETTE_FAILURE));
      return Promise.reject();
    }

    dispatch(changePaletteSuccess(palette.color, palette.tagline));
  };

export const changeLogo =
  (updatedLogo) =>
  async (dispatch, getState, { api }) => {
    const {
      subscriberInfo: { id },
      resources: {
        branding: { logo },
      },
    } = getState();

    if (updatedLogo === logo) return Promise.resolve();

    const result = await api.ssm.bpResources.updateLogo(id, updatedLogo);

    if (isFailure(result)) {
      dispatch(Notificator.error("couldnt_save_logo"));
      dispatch(generalFailure(result.error, CHANGE_LOGO_FAILURE));
      return Promise.reject();
    }

    dispatch(changeLogoSuccess(updatedLogo));
  };

export const getWebContentPreview =
  () =>
  async (dispatch, getState, { api }) => {
    const state = getState();
    const { id } = state.subscriberInfo;
    const previewParams = getWebContentPreviewParams(state);

    const result = await api.ssm.bpResources.getPreview(
      id,
      ResourceName.WebContent,
      previewParams
    );

    if (isFailure(result)) {
      dispatch(Notificator.error("error_failed_to_load_data"));
      dispatch(generalFailure(result.error, LOAD_PREVIEW_FAILURE));
      return Promise.reject();
    }

    localStorage.setItem("web-filtering", result.data);
  };

export const LOAD_LOGO_SUCCESS = "[RESOURCES] [WEB_CONTENT] LOAD_LOGO_SUCCESS";
export const LOAD_LOGO_FAILURE = "[RESOURCES] [WEB_CONTENT] LOAD_LOGO_FAILURE";
export const LOAD_PREVIEW_FAILURE =
  "[RESOURCES] [WEB_CONTENT] LOAD_PREVIEW_FAILURE";
export const RESET_TO_SAVE = "[RESOURCES] [WEB_CONTENT] RESET_TO_SAVE";
export const CHANGE_PALETTE_SUCCESS =
  "[RESOURCES] [WEB_CONTENT] CHANGE_PALETTE_SUCCESS";
export const CHANGE_PALETTE_FAILURE =
  "[RESOURCES] [WEB_CONTENT] CHANGE_PALETTE_FAILURE";
export const CHANGE_CUSTOM_COLOR =
  "[RESOURCES] [WEB_CONTENT] CHANGE_CUSTOM_COLOR";
export const CHANGE_TAGLINE_TO_SAVE =
  "[RESOURCES] [WEB_CONTENT] CHANGE_TAGLINE_TO_SAVE";
export const CHANGE_COLOR_TO_SAVE =
  "[RESOURCES] [WEB_CONTENT] CHANGE_COLOR_TO_SAVE";
export const CHANGE_LOGO_TO_SAVE = "[RESOURCES] CHANGE_LOGO_TO_SAVE";
export const CHANGE_LOGO_SUCCESS =
  "[RESOURCES] [WEB_CONTENT] CHANGE_LOGO_SUCCESS";
export const CHANGE_LOGO_FAILURE =
  "[RESOURCES] [WEB_CONTENT] CHANGE_LOGO_FAILURE";

export const loadLogoSuccess = (logo) => ({
  type: LOAD_LOGO_SUCCESS,
  payload: { logo },
});
export const resetToSave = () => ({
  type: RESET_TO_SAVE,
});
export const changePaletteSuccess = (color, tagline) => ({
  type: CHANGE_PALETTE_SUCCESS,
  payload: { color, tagline },
});
export const changeCustomColor = (customColor) => ({
  type: CHANGE_CUSTOM_COLOR,
  payload: customColor.toUpperCase(),
});
export const changeTaglineToSave = (tagline) => ({
  type: CHANGE_TAGLINE_TO_SAVE,
  payload: tagline,
});
export const changeColorToSave = (color) => ({
  type: CHANGE_COLOR_TO_SAVE,
  payload: color.toUpperCase(),
});
export const changeLogoToSave = (logo) => ({
  type: CHANGE_LOGO_TO_SAVE,
  payload: { logo },
});
export const changeLogoSuccess = (logo) => ({
  type: CHANGE_LOGO_SUCCESS,
  payload: { logo },
});

export const generalFailure = (error, type) => ({
  type,
  payload: error,
});
